/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

const envConfig = {
  appName: process.env.REACT_APP_NAME,
  description: process.env.REACT_APP_DESCRIPTION,
  logoUrl: process.env.REACT_APP_LOGO_URL,
  backendApiUrl:process.env.REACT_APP_BACKEND_API_URL,
  backendTokenUrl:process.env.REACT_APP_BACKEND_TOKEN_URL,
  clientKey:process.env.REACT_APP_CLIENT_KEY,
  clientSecret:process.env.REACT_APP_CLIENT_SECRET,
  fileServerUrl:process.env.REACT_APP_FILE_SERVER_API_URL || "http://localhost:5000",
  fileServerApiKey:process.env.REACT_APP_FILE_SERVER_API_KEY,
  eventsAllowedApplicationId:process.env.REACT_APP_EVENTS_ALLOWED_APPLICATION_ID,
  // Feature toggles for installed applications. Only an explicit "false"
  // hides the button, so existing deployments keep current behaviour.
  showApplicationDelete: process.env.REACT_APP_SHOW_APPLICATION_DELETE !== 'false',
  showApplicationRollback: process.env.REACT_APP_SHOW_APPLICATION_ROLLBACK !== 'false'
};

export default envConfig;
